import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CheckoutComponent } from './checkout/checkout.component';
import { SessioncheckoutComponent } from './sessioncheckout/sessioncheckout.component';
import { ClubsponsorshipcheckoutComponent } from './clubsponsorshipcheckout/clubsponsorshipcheckout.component';
import { BuyticketcheckoutComponent } from './buyticketcheckout/buyticketcheckout.component';


const routes: Routes = [{path: "checkout", component: CheckoutComponent},
{path: "sessioncheckout", component: SessioncheckoutComponent},
{path: "buyticketcheckout", component: BuyticketcheckoutComponent},
{ path: "clubsponsorshipcheckout/:slug", component: ClubsponsorshipcheckoutComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CheckoutRoutingModule { }
